module.exports = __webpack_public_path__ + "static/media/project.82aaadf8.png";